window.HS_SWATCH_DATA = window.HS_SWATCH_DATA || {};
window.HS_SWATCH_DATA["roller-blackout"] = {
  "product_key": "roller-blackout",
  "minimum_order_quantity": 5,
  "tier_guide": [
    {
      "tier": "Tier 1",
      "label": "Budget Friendly"
    },
    {
      "tier": "Tier 2",
      "label": "Mid Range Residential"
    },
    {
      "tier": "Tier 3",
      "label": "Premium Collection"
    }
  ],
  "swatches": [
    {
      "id": "roller-blackout-MB8-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB8",
      "fabric_code": "MB8-001",
      "web_name": "Fresh Snow",
      "name_key": "fresh-snow",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjgtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842151643-MB8-001.jpg",
      "search_text": "MB8-001 Fresh Snow Budget Friendly",
      "sort_order": 0,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB8-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB8",
      "fabric_code": "MB8-002",
      "web_name": "Warm Pearl",
      "name_key": "warm-pearl",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjgtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842151643-MB8-002.jpg",
      "search_text": "MB8-002 Warm Pearl Budget Friendly",
      "sort_order": 1,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB8-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB8",
      "fabric_code": "MB8-003",
      "web_name": "Soft Stone",
      "name_key": "soft-stone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjgtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025842151643-MB8-003.jpg",
      "search_text": "MB8-003 Soft Stone Budget Friendly",
      "sort_order": 2,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB12-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB12",
      "fabric_code": "MB12-001",
      "web_name": "Soft Cloud",
      "name_key": "soft-cloud",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjEyLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB12-001.jpg",
      "search_text": "MB12-001 Soft Cloud Budget Friendly",
      "sort_order": 3,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB12-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB12",
      "fabric_code": "MB12-002",
      "web_name": "Natural Linen",
      "name_key": "natural-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjEyLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB12-002.jpg",
      "search_text": "MB12-002 Natural Linen Budget Friendly",
      "sort_order": 4,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB12-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB12",
      "fabric_code": "MB12-003",
      "web_name": "Warm Sand",
      "name_key": "warm-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjEyLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB12-003.jpg",
      "search_text": "MB12-003 Warm Sand Budget Friendly",
      "sort_order": 5,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB12-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB12",
      "fabric_code": "MB12-004",
      "web_name": "Urban Ash",
      "name_key": "urban-ash",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjEyLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB12-004.jpg",
      "search_text": "MB12-004 Urban Ash Budget Friendly",
      "sort_order": 6,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB12-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB12",
      "fabric_code": "MB12-005",
      "web_name": "Cool Pebble",
      "name_key": "cool-pebble",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjEyLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB12-005.jpg",
      "search_text": "MB12-005 Cool Pebble Budget Friendly",
      "sort_order": 7,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB15-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB15",
      "fabric_code": "MB15-001",
      "web_name": "Soft Ivory",
      "name_key": "soft-ivory",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjE1LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB15-001.jpg",
      "search_text": "MB15-001 Soft Ivory Budget Friendly",
      "sort_order": 8,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB15-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB15",
      "fabric_code": "MB15-002",
      "web_name": "Cream Breeze",
      "name_key": "cream-breeze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjE1LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB15-002.jpg",
      "search_text": "MB15-002 Cream Breeze Budget Friendly",
      "sort_order": 9,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB15-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB15",
      "fabric_code": "MB15-003",
      "web_name": "Morning Mist",
      "name_key": "morning-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjE1LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB15-003.jpg",
      "search_text": "MB15-003 Morning Mist Budget Friendly",
      "sort_order": 10,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB15-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB15",
      "fabric_code": "MB15-004",
      "web_name": "Steel Harbor",
      "name_key": "steel-harbor",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjE1LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB15-004.jpg",
      "search_text": "MB15-004 Steel Harbor Budget Friendly",
      "sort_order": 11,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB27-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB27",
      "fabric_code": "MB27-001",
      "web_name": "Arctic White",
      "name_key": "arctic-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI3LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB27-001.jpg",
      "search_text": "MB27-001 Arctic White Budget Friendly",
      "sort_order": 12,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB27-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB27",
      "fabric_code": "MB27-002",
      "web_name": "Soft Almond",
      "name_key": "soft-almond",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI3LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB27-002.jpg",
      "search_text": "MB27-002 Soft Almond Budget Friendly",
      "sort_order": 13,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB27-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB27",
      "fabric_code": "MB27-003",
      "web_name": "Frosted Sky",
      "name_key": "frosted-sky",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI3LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB27-003.jpg",
      "search_text": "MB27-003 Frosted Sky Budget Friendly",
      "sort_order": 14,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB27-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB27",
      "fabric_code": "MB27-004",
      "web_name": "Quiet Stone",
      "name_key": "quiet-stone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI3LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB27-004.jpg",
      "search_text": "MB27-004 Quiet Stone Budget Friendly",
      "sort_order": 15,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB27-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB27",
      "fabric_code": "MB27-005",
      "web_name": "Driftwood Taupe",
      "name_key": "driftwood-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI3LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB27-005.jpg",
      "search_text": "MB27-005 Driftwood Taupe Budget Friendly",
      "sort_order": 16,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB27-006",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB27",
      "fabric_code": "MB27-006",
      "web_name": "Midnight Slate",
      "name_key": "midnight-slate",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI3LTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB27-006.jpg",
      "search_text": "MB27-006 Midnight Slate Budget Friendly",
      "sort_order": 17,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB28-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB28",
      "fabric_code": "MB28-001",
      "web_name": "Crystal White",
      "name_key": "crystal-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI4LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB28-001.jpg",
      "search_text": "MB28-001 Crystal White Budget Friendly",
      "sort_order": 18,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB28-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB28",
      "fabric_code": "MB28-002",
      "web_name": "Vanilla Cream",
      "name_key": "vanilla-cream",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI4LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB28-002.jpg",
      "search_text": "MB28-002 Vanilla Cream Budget Friendly",
      "sort_order": 19,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB28-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB28",
      "fabric_code": "MB28-003",
      "web_name": "Soft Wheat",
      "name_key": "soft-wheat",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI4LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB28-003.jpg",
      "search_text": "MB28-003 Soft Wheat Budget Friendly",
      "sort_order": 20,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB28-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB28",
      "fabric_code": "MB28-004",
      "web_name": "Silver Haze",
      "name_key": "silver-haze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI4LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB28-004.jpg",
      "search_text": "MB28-004 Silver Haze Budget Friendly",
      "sort_order": 21,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB28-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB28",
      "fabric_code": "MB28-005",
      "web_name": "Coastal Gray",
      "name_key": "coastal-gray",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI4LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB28-005.jpg",
      "search_text": "MB28-005 Coastal Gray Budget Friendly",
      "sort_order": 22,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB28-006",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Roller Shades Blackout - Budget Friendly",
      "fabric_series": "MB28",
      "fabric_code": "MB28-006",
      "web_name": "Charcoal Night",
      "name_key": "charcoal-night",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MjE1MTY0My1NQjI4LTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025842151643-MB28-006.jpg",
      "search_text": "MB28-006 Charcoal Night Budget Friendly",
      "sort_order": 23,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB1-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB1",
      "fabric_code": "MB1-001",
      "web_name": "Snow Drift",
      "name_key": "snow-drift",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjEtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB1-001.jpg",
      "search_text": "MB1-001 Snow Drift Premium Collection",
      "sort_order": 24,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB1-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB1",
      "fabric_code": "MB1-002",
      "web_name": "Vanilla Linen",
      "name_key": "vanilla-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjEtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB1-002.jpg",
      "search_text": "MB1-002 Vanilla Linen Premium Collection",
      "sort_order": 25,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB1-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB1",
      "fabric_code": "MB1-003",
      "web_name": "Cloud Weave",
      "name_key": "cloud-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjEtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB1-003.jpg",
      "search_text": "MB1-003 Cloud Weave Premium Collection",
      "sort_order": 26,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB1-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB1",
      "fabric_code": "MB1-004",
      "web_name": "Steel Mist",
      "name_key": "steel-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjEtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB1-004.jpg",
      "search_text": "MB1-004 Steel Mist Premium Collection",
      "sort_order": 27,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB3-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB3",
      "fabric_code": "MB3-001",
      "web_name": "Fresh Cotton",
      "name_key": "fresh-cotton",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjMtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB3-001.jpg",
      "search_text": "MB3-001 Fresh Cotton Premium Collection",
      "sort_order": 28,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB3-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB3",
      "fabric_code": "MB3-002",
      "web_name": "Soft Pearl",
      "name_key": "soft-pearl",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjMtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB3-002.jpg",
      "search_text": "MB3-002 Soft Pearl Premium Collection",
      "sort_order": 29,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB3-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB3",
      "fabric_code": "MB3-003",
      "web_name": "Light Frost",
      "name_key": "light-frost",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjMtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB3-003.jpg",
      "search_text": "MB3-003 Light Frost Premium Collection",
      "sort_order": 30,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB3-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB3",
      "fabric_code": "MB3-004",
      "web_name": "Glacier Linen",
      "name_key": "glacier-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjMtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB3-004.jpg",
      "search_text": "MB3-004 Glacier Linen Premium Collection",
      "sort_order": 31,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB3-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB3",
      "fabric_code": "MB3-005",
      "web_name": "Silver Breeze",
      "name_key": "silver-breeze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjMtMDA1LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB3-005.jpg",
      "search_text": "MB3-005 Silver Breeze Premium Collection",
      "sort_order": 32,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB3-006",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB3",
      "fabric_code": "MB3-006",
      "web_name": "Warm Pebble",
      "name_key": "warm-pebble",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjMtMDA2LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB3-006.jpg",
      "search_text": "MB3-006 Warm Pebble Premium Collection",
      "sort_order": 33,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB3-007",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB3",
      "fabric_code": "MB3-007",
      "web_name": "Espresso Weave",
      "name_key": "espresso-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjMtMDA3LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB3-007.jpg",
      "search_text": "MB3-007 Espresso Weave Premium Collection",
      "sort_order": 34,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB3-008",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB3",
      "fabric_code": "MB3-008",
      "web_name": "Midnight Charcoal Sand",
      "name_key": "midnight-charcoal-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjMtMDA4LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB3-008.jpg",
      "search_text": "MB3-008 Midnight Charcoal Sand Premium Collection",
      "sort_order": 35,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB5-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB5",
      "fabric_code": "MB5-001",
      "web_name": "Morning Snow",
      "name_key": "morning-snow",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjUtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB5-001.jpg",
      "search_text": "MB5-001 Morning Snow Premium Collection",
      "sort_order": 36,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB5-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB5",
      "fabric_code": "MB5-002",
      "web_name": "Soft Ivory Drift",
      "name_key": "soft-ivory-drift",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjUtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB5-002.jpg",
      "search_text": "MB5-002 Soft Ivory Drift Premium Collection",
      "sort_order": 37,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB5-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB5",
      "fabric_code": "MB5-003",
      "web_name": "Sand Whisper",
      "name_key": "sand-whisper",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjUtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB5-003.jpg",
      "search_text": "MB5-003 Sand Whisper Premium Collection",
      "sort_order": 38,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB5-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB5",
      "fabric_code": "MB5-004",
      "web_name": "Stone Linen",
      "name_key": "stone-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjUtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB5-004.jpg",
      "search_text": "MB5-004 Stone Linen Premium Collection",
      "sort_order": 39,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB7-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB7",
      "fabric_code": "MB7-001",
      "web_name": "Cloud Canvas",
      "name_key": "cloud-canvas",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjctMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB7-001.jpg",
      "search_text": "MB7-001 Cloud Canvas Premium Collection",
      "sort_order": 40,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB7-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB7",
      "fabric_code": "MB7-002",
      "web_name": "Oatmilk Weave",
      "name_key": "oatmilk-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjctMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB7-002.jpg",
      "search_text": "MB7-002 Oatmilk Weave Premium Collection",
      "sort_order": 41,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB7-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB7",
      "fabric_code": "MB7-003",
      "web_name": "Silver Linen",
      "name_key": "silver-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjctMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB7-003.jpg",
      "search_text": "MB7-003 Silver Linen Premium Collection",
      "sort_order": 42,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB9-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB9",
      "fabric_code": "MB9-001",
      "web_name": "Soft Cloud Mist",
      "name_key": "soft-cloud-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjktMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB9-001.jpg",
      "search_text": "MB9-001 Soft Cloud Mist Premium Collection",
      "sort_order": 43,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB9-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB9",
      "fabric_code": "MB9-002",
      "web_name": "Natural Flax",
      "name_key": "natural-flax",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjktMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB9-002.jpg",
      "search_text": "MB9-002 Natural Flax Premium Collection",
      "sort_order": 44,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB9-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB9",
      "fabric_code": "MB9-003",
      "web_name": "Honey Linen",
      "name_key": "honey-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjktMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB9-003.jpg",
      "search_text": "MB9-003 Honey Linen Premium Collection",
      "sort_order": 45,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB9-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB9",
      "fabric_code": "MB9-004",
      "web_name": "Driftwood Weave",
      "name_key": "driftwood-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjktMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB9-004.jpg",
      "search_text": "MB9-004 Driftwood Weave Premium Collection",
      "sort_order": 46,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB9-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB9",
      "fabric_code": "MB9-005",
      "web_name": "Charcoal Deep Night",
      "name_key": "charcoal-deep-night",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjktMDA1LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132940230875-MB9-005.jpg",
      "search_text": "MB9-005 Charcoal Deep Night Premium Collection",
      "sort_order": 47,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB13-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB13",
      "fabric_code": "MB13-001",
      "web_name": "Pure Snow",
      "name_key": "pure-snow",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjEzLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB13-001.jpg",
      "search_text": "MB13-001 Pure Snow Premium Collection",
      "sort_order": 48,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB13-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB13",
      "fabric_code": "MB13-002",
      "web_name": "Morning Mist Sheer",
      "name_key": "morning-mist-sheer",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjEzLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB13-002.jpg",
      "search_text": "MB13-002 Morning Mist Sheer Premium Collection",
      "sort_order": 49,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB13-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB13",
      "fabric_code": "MB13-003",
      "web_name": "Vanilla Weave",
      "name_key": "vanilla-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjEzLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB13-003.jpg",
      "search_text": "MB13-003 Vanilla Weave Premium Collection",
      "sort_order": 50,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB13-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB13",
      "fabric_code": "MB13-004",
      "web_name": "Coastal Gray Drift",
      "name_key": "coastal-gray-drift",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjEzLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB13-004.jpg",
      "search_text": "MB13-004 Coastal Gray Drift Premium Collection",
      "sort_order": 51,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB13-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB13",
      "fabric_code": "MB13-005",
      "web_name": "Smoky Drift",
      "name_key": "smoky-drift",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjEzLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB13-005.jpg",
      "search_text": "MB13-005 Smoky Drift Premium Collection",
      "sort_order": 52,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB17-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB17",
      "fabric_code": "MB17-001",
      "web_name": "Arctic White Sand",
      "name_key": "arctic-white-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjE3LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB17-001.jpg",
      "search_text": "MB17-001 Arctic White Sand Premium Collection",
      "sort_order": 53,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB17-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB17",
      "fabric_code": "MB17-002",
      "web_name": "Urban Fog",
      "name_key": "urban-fog",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjE3LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB17-002.jpg",
      "search_text": "MB17-002 Urban Fog Premium Collection",
      "sort_order": 54,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB17-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB17",
      "fabric_code": "MB17-003",
      "web_name": "Steel Breeze",
      "name_key": "steel-breeze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjE3LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB17-003.jpg",
      "search_text": "MB17-003 Steel Breeze Premium Collection",
      "sort_order": 55,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB18-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB18",
      "fabric_code": "MB18-001",
      "web_name": "Fresh Linen",
      "name_key": "fresh-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjE4LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB18-001.jpg",
      "search_text": "MB18-001 Fresh Linen Premium Collection",
      "sort_order": 56,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB18-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB18",
      "fabric_code": "MB18-002",
      "web_name": "Sand Dune",
      "name_key": "sand-dune",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjE4LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB18-002.jpg",
      "search_text": "MB18-002 Sand Dune Premium Collection",
      "sort_order": 57,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB18-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB18",
      "fabric_code": "MB18-003",
      "web_name": "Beach Pebble",
      "name_key": "beach-pebble",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjE4LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB18-003.jpg",
      "search_text": "MB18-003 Beach Pebble Premium Collection",
      "sort_order": 58,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB18-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB18",
      "fabric_code": "MB18-004",
      "web_name": "Sea Fog",
      "name_key": "sea-fog",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjE4LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB18-004.jpg",
      "search_text": "MB18-004 Sea Fog Premium Collection",
      "sort_order": 59,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB18-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB18",
      "fabric_code": "MB18-005",
      "web_name": "Midnight Weave",
      "name_key": "midnight-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjE4LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB18-005.jpg",
      "search_text": "MB18-005 Midnight Weave Premium Collection",
      "sort_order": 60,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB23-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB23",
      "fabric_code": "MB23-001",
      "web_name": "Snowfall White",
      "name_key": "snowfall-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjIzLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB23-001.jpg",
      "search_text": "MB23-001 Snowfall White Premium Collection",
      "sort_order": 61,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB23-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB23",
      "fabric_code": "MB23-002",
      "web_name": "Soft Cotton",
      "name_key": "soft-cotton",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjIzLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB23-002.jpg",
      "search_text": "MB23-002 Soft Cotton Premium Collection",
      "sort_order": 62,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB23-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB23",
      "fabric_code": "MB23-003",
      "web_name": "Oyster Linen",
      "name_key": "oyster-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjIzLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB23-003.jpg",
      "search_text": "MB23-003 Oyster Linen Premium Collection",
      "sort_order": 63,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB23-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB23",
      "fabric_code": "MB23-004",
      "web_name": "Warm Pebble Mist",
      "name_key": "warm-pebble-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjIzLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB23-004.jpg",
      "search_text": "MB23-004 Warm Pebble Mist Premium Collection",
      "sort_order": 64,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB23-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB23",
      "fabric_code": "MB23-005",
      "web_name": "Cool Ash",
      "name_key": "cool-ash",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjIzLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB23-005.jpg",
      "search_text": "MB23-005 Cool Ash Premium Collection",
      "sort_order": 65,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB24-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB24",
      "fabric_code": "MB24-001",
      "web_name": "Frost White",
      "name_key": "frost-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjI0LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB24-001.jpg",
      "search_text": "MB24-001 Frost White Premium Collection",
      "sort_order": 66,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB24-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB24",
      "fabric_code": "MB24-002",
      "web_name": "Drift Linen",
      "name_key": "drift-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjI0LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB24-002.jpg",
      "search_text": "MB24-002 Drift Linen Premium Collection",
      "sort_order": 67,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB24-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB24",
      "fabric_code": "MB24-003",
      "web_name": "Soft Almond Bite",
      "name_key": "soft-almond-bite",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjI0LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB24-003.jpg",
      "search_text": "MB24-003 Soft Almond Bite Premium Collection",
      "sort_order": 68,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB24-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB24",
      "fabric_code": "MB24-004",
      "web_name": "Morning Cloud",
      "name_key": "morning-cloud",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjI0LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB24-004.jpg",
      "search_text": "MB24-004 Morning Cloud Premium Collection",
      "sort_order": 69,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB24-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB24",
      "fabric_code": "MB24-005",
      "web_name": "Silver Mist",
      "name_key": "silver-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjI0LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB24-005.jpg",
      "search_text": "MB24-005 Silver Mist Premium Collection",
      "sort_order": 70,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB25-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB25",
      "fabric_code": "MB25-001",
      "web_name": "Soft Ivory Sand",
      "name_key": "soft-ivory-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjI1LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB25-001.jpg",
      "search_text": "MB25-001 Soft Ivory Sand Premium Collection",
      "sort_order": 71,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB25-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB25",
      "fabric_code": "MB25-002",
      "web_name": "Natural Wheat Thread",
      "name_key": "natural-wheat-thread",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjI1LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB25-002.jpg",
      "search_text": "MB25-002 Natural Wheat Thread Premium Collection",
      "sort_order": 72,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB25-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB25",
      "fabric_code": "MB25-003",
      "web_name": "Slate Gray",
      "name_key": "slate-gray",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjI1LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB25-003.jpg",
      "search_text": "MB25-003 Slate Gray Premium Collection",
      "sort_order": 73,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB25-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB25",
      "fabric_code": "MB25-004",
      "web_name": "Deep Charcoal",
      "name_key": "deep-charcoal",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjI1LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB25-004.jpg",
      "search_text": "MB25-004 Deep Charcoal Premium Collection",
      "sort_order": 74,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB25-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Roller Shades Blackout - Premium Collection",
      "fabric_series": "MB25",
      "fabric_code": "MB25-005",
      "web_name": "Mocha Stone",
      "name_key": "mocha-stone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjk0MDIzMDg3NS1NQjI1LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132940230875-MB25-005.jpg",
      "search_text": "MB25-005 Mocha Stone Premium Collection",
      "sort_order": 75,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB2-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB2",
      "fabric_code": "MB2-001",
      "web_name": "Arctic White Breeze",
      "name_key": "arctic-white-breeze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjItMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB2-001.jpg",
      "search_text": "MB2-001 Arctic White Breeze Mid Range Residential",
      "sort_order": 76,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB2-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB2",
      "fabric_code": "MB2-002",
      "web_name": "Warm Ivory",
      "name_key": "warm-ivory",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjItMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB2-002.jpg",
      "search_text": "MB2-002 Warm Ivory Mid Range Residential",
      "sort_order": 77,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB2-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB2",
      "fabric_code": "MB2-003",
      "web_name": "Soft Gray",
      "name_key": "soft-gray",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjItMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB2-003.jpg",
      "search_text": "MB2-003 Soft Gray Mid Range Residential",
      "sort_order": 78,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB4-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB4",
      "fabric_code": "MB4-001",
      "web_name": "Cream Linen",
      "name_key": "cream-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjQtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB4-001.jpg",
      "search_text": "MB4-001 Cream Linen Mid Range Residential",
      "sort_order": 79,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB4-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB4",
      "fabric_code": "MB4-002",
      "web_name": "Sand Beige",
      "name_key": "sand-beige",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjQtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB4-002.jpg",
      "search_text": "MB4-002 Sand Beige Mid Range Residential",
      "sort_order": 80,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB4-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB4",
      "fabric_code": "MB4-003",
      "web_name": "Flax Tan",
      "name_key": "flax-tan",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjQtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB4-003.jpg",
      "search_text": "MB4-003 Flax Tan Mid Range Residential",
      "sort_order": 81,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB4-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB4",
      "fabric_code": "MB4-004",
      "web_name": "Neutral Stone",
      "name_key": "neutral-stone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjQtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB4-004.jpg",
      "search_text": "MB4-004 Neutral Stone Mid Range Residential",
      "sort_order": 82,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB4-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB4",
      "fabric_code": "MB4-005",
      "web_name": "Slate Smoke",
      "name_key": "slate-smoke",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjQtMDA1LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB4-005.jpg",
      "search_text": "MB4-005 Slate Smoke Mid Range Residential",
      "sort_order": 83,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB4-006",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB4",
      "fabric_code": "MB4-006",
      "web_name": "Rich Charcoal",
      "name_key": "rich-charcoal",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjQtMDA2LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB4-006.jpg",
      "search_text": "MB4-006 Rich Charcoal Mid Range Residential",
      "sort_order": 84,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB6-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB6",
      "fabric_code": "MB6-001",
      "web_name": "Studio White",
      "name_key": "studio-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjYtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB6-001.jpg",
      "search_text": "MB6-001 Studio White Mid Range Residential",
      "sort_order": 85,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB6-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB6",
      "fabric_code": "MB6-002",
      "web_name": "Soft Porcelain",
      "name_key": "soft-porcelain",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjYtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB6-002.jpg",
      "search_text": "MB6-002 Soft Porcelain Mid Range Residential",
      "sort_order": 86,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB6-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB6",
      "fabric_code": "MB6-003",
      "web_name": "Urban Slate",
      "name_key": "urban-slate",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjYtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB6-003.jpg",
      "search_text": "MB6-003 Urban Slate Mid Range Residential",
      "sort_order": 87,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB6-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB6",
      "fabric_code": "MB6-004",
      "web_name": "Graphite Night",
      "name_key": "graphite-night",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjYtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9132928827611-MB6-004.jpg",
      "search_text": "MB6-004 Graphite Night Mid Range Residential",
      "sort_order": 88,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB10-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB10",
      "fabric_code": "MB10-001",
      "web_name": "Cloud White",
      "name_key": "cloud-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjEwLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB10-001.jpg",
      "search_text": "MB10-001 Cloud White Mid Range Residential",
      "sort_order": 89,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB10-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB10",
      "fabric_code": "MB10-002",
      "web_name": "Warm Alabaster",
      "name_key": "warm-alabaster",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjEwLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB10-002.jpg",
      "search_text": "MB10-002 Warm Alabaster Mid Range Residential",
      "sort_order": 90,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB10-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB10",
      "fabric_code": "MB10-003",
      "web_name": "Pearl Mist",
      "name_key": "pearl-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjEwLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB10-003.jpg",
      "search_text": "MB10-003 Pearl Mist Mid Range Residential",
      "sort_order": 91,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB10-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB10",
      "fabric_code": "MB10-004",
      "web_name": "Natural Canvas",
      "name_key": "natural-canvas",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjEwLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB10-004.jpg",
      "search_text": "MB10-004 Natural Canvas Mid Range Residential",
      "sort_order": 92,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB10-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB10",
      "fabric_code": "MB10-005",
      "web_name": "Toasted Taupe",
      "name_key": "toasted-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjEwLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB10-005.jpg",
      "search_text": "MB10-005 Toasted Taupe Mid Range Residential",
      "sort_order": 93,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB10-006",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB10",
      "fabric_code": "MB10-006",
      "web_name": "Architect Gray",
      "name_key": "architect-gray",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjEwLTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB10-006.jpg",
      "search_text": "MB10-006 Architect Gray Mid Range Residential",
      "sort_order": 94,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB10-007",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB10",
      "fabric_code": "MB10-007",
      "web_name": "Steel Slate",
      "name_key": "steel-slate",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjEwLTAwNy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB10-007.jpg",
      "search_text": "MB10-007 Steel Slate Mid Range Residential",
      "sort_order": 95,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB10-008",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB10",
      "fabric_code": "MB10-008",
      "web_name": "Shadow Charcoal",
      "name_key": "shadow-charcoal",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjEwLTAwOC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB10-008.jpg",
      "search_text": "MB10-008 Shadow Charcoal Mid Range Residential",
      "sort_order": 96,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB11-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB11",
      "fabric_code": "MB11-001",
      "web_name": "Snow Drift Breeze",
      "name_key": "snow-drift-breeze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjExLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB11-001.jpg",
      "search_text": "MB11-001 Snow Drift Breeze Mid Range Residential",
      "sort_order": 97,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB11-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB11",
      "fabric_code": "MB11-002",
      "web_name": "Warm Shell",
      "name_key": "warm-shell",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjExLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB11-002.jpg",
      "search_text": "MB11-002 Warm Shell Mid Range Residential",
      "sort_order": 98,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB11-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB11",
      "fabric_code": "MB11-003",
      "web_name": "Natural Hemp",
      "name_key": "natural-hemp",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjExLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB11-003.jpg",
      "search_text": "MB11-003 Natural Hemp Mid Range Residential",
      "sort_order": 99,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB11-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB11",
      "fabric_code": "MB11-004",
      "web_name": "Cool Cement",
      "name_key": "cool-cement",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjExLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB11-004.jpg",
      "search_text": "MB11-004 Cool Cement Mid Range Residential",
      "sort_order": 100,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB11-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB11",
      "fabric_code": "MB11-005",
      "web_name": "Smoked Iron",
      "name_key": "smoked-iron",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjExLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB11-005.jpg",
      "search_text": "MB11-005 Smoked Iron Mid Range Residential",
      "sort_order": 101,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB11-006",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB11",
      "fabric_code": "MB11-006",
      "web_name": "Deep Graphite",
      "name_key": "deep-graphite",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjExLTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB11-006.jpg",
      "search_text": "MB11-006 Deep Graphite Mid Range Residential",
      "sort_order": 102,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB14-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB14",
      "fabric_code": "MB14-001",
      "web_name": "Porcelain White",
      "name_key": "porcelain-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE0LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB14-001.jpg",
      "search_text": "MB14-001 Porcelain White Mid Range Residential",
      "sort_order": 103,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB14-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB14",
      "fabric_code": "MB14-002",
      "web_name": "Soft Biscuit",
      "name_key": "soft-biscuit",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE0LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB14-002.jpg",
      "search_text": "MB14-002 Soft Biscuit Mid Range Residential",
      "sort_order": 104,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB14-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB14",
      "fabric_code": "MB14-003",
      "web_name": "Raw Linen",
      "name_key": "raw-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE0LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB14-003.jpg",
      "search_text": "MB14-003 Raw Linen Mid Range Residential",
      "sort_order": 105,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB14-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB14",
      "fabric_code": "MB14-004",
      "web_name": "Warm Pebble Dust",
      "name_key": "warm-pebble-dust",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE0LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB14-004.jpg",
      "search_text": "MB14-004 Warm Pebble Dust Mid Range Residential",
      "sort_order": 106,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB14-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB14",
      "fabric_code": "MB14-005",
      "web_name": "Charcoal Stone",
      "name_key": "charcoal-stone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE0LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB14-005.jpg",
      "search_text": "MB14-005 Charcoal Stone Mid Range Residential",
      "sort_order": 107,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB14-006",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB14",
      "fabric_code": "MB14-006",
      "web_name": "Night Ash",
      "name_key": "night-ash",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE0LTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB14-006.jpg",
      "search_text": "MB14-006 Night Ash Mid Range Residential",
      "sort_order": 108,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB16-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB16",
      "fabric_code": "MB16-001",
      "web_name": "Ivory Frost",
      "name_key": "ivory-frost",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE2LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB16-001.jpg",
      "search_text": "MB16-001 Ivory Frost Mid Range Residential",
      "sort_order": 109,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB16-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB16",
      "fabric_code": "MB16-002",
      "web_name": "Soft Almond Sand",
      "name_key": "soft-almond-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE2LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB16-002.jpg",
      "search_text": "MB16-002 Soft Almond Sand Mid Range Residential",
      "sort_order": 110,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB19-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB19",
      "fabric_code": "MB19-001",
      "web_name": "Polar Linen",
      "name_key": "polar-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE5LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB19-001.jpg",
      "search_text": "MB19-001 Polar Linen Mid Range Residential",
      "sort_order": 111,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB19-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB19",
      "fabric_code": "MB19-002",
      "web_name": "Warm Parchment",
      "name_key": "warm-parchment",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE5LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB19-002.jpg",
      "search_text": "MB19-002 Warm Parchment Mid Range Residential",
      "sort_order": 112,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB19-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB19",
      "fabric_code": "MB19-003",
      "web_name": "Stone Mist",
      "name_key": "stone-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE5LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB19-003.jpg",
      "search_text": "MB19-003 Stone Mist Mid Range Residential",
      "sort_order": 113,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB19-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB19",
      "fabric_code": "MB19-004",
      "web_name": "Carbon Slate",
      "name_key": "carbon-slate",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjE5LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB19-004.jpg",
      "search_text": "MB19-004 Carbon Slate Mid Range Residential",
      "sort_order": 114,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB20-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB20",
      "fabric_code": "MB20-001",
      "web_name": "Soft Vanilla",
      "name_key": "soft-vanilla",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIwLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB20-001.jpg",
      "search_text": "MB20-001 Soft Vanilla Mid Range Residential",
      "sort_order": 115,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB20-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB20",
      "fabric_code": "MB20-002",
      "web_name": "Wheat Beige",
      "name_key": "wheat-beige",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIwLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB20-002.jpg",
      "search_text": "MB20-002 Wheat Beige Mid Range Residential",
      "sort_order": 116,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB20-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB20",
      "fabric_code": "MB20-003",
      "web_name": "Mineral Gray",
      "name_key": "mineral-gray",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIwLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB20-003.jpg",
      "search_text": "MB20-003 Mineral Gray Mid Range Residential",
      "sort_order": 117,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB21-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB21",
      "fabric_code": "MB21-001",
      "web_name": "Bright Cotton",
      "name_key": "bright-cotton",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIxLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB21-001.jpg",
      "search_text": "MB21-001 Bright Cotton Mid Range Residential",
      "sort_order": 118,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB21-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB21",
      "fabric_code": "MB21-002",
      "web_name": "Sandy Taupe",
      "name_key": "sandy-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIxLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB21-002.jpg",
      "search_text": "MB21-002 Sandy Taupe Mid Range Residential",
      "sort_order": 119,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB21-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB21",
      "fabric_code": "MB21-003",
      "web_name": "Ash Concrete",
      "name_key": "ash-concrete",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIxLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB21-003.jpg",
      "search_text": "MB21-003 Ash Concrete Mid Range Residential",
      "sort_order": 120,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB21-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB21",
      "fabric_code": "MB21-004",
      "web_name": "Dark Graphite",
      "name_key": "dark-graphite",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIxLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB21-004.jpg",
      "search_text": "MB21-004 Dark Graphite Mid Range Residential",
      "sort_order": 121,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB22-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB22",
      "fabric_code": "MB22-001",
      "web_name": "Chalk White",
      "name_key": "chalk-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIyLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB22-001.jpg",
      "search_text": "MB22-001 Chalk White Mid Range Residential",
      "sort_order": 122,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB22-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB22",
      "fabric_code": "MB22-002",
      "web_name": "Warm Dune",
      "name_key": "warm-dune",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIyLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB22-002.jpg",
      "search_text": "MB22-002 Warm Dune Mid Range Residential",
      "sort_order": 123,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB22-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB22",
      "fabric_code": "MB22-003",
      "web_name": "Weathered Stone",
      "name_key": "weathered-stone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIyLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB22-003.jpg",
      "search_text": "MB22-003 Weathered Stone Mid Range Residential",
      "sort_order": 124,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB22-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB22",
      "fabric_code": "MB22-004",
      "web_name": "Blackened Slate",
      "name_key": "blackened-slate",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjIyLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB22-004.jpg",
      "search_text": "MB22-004 Blackened Slate Mid Range Residential",
      "sort_order": 125,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB26-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB26",
      "fabric_code": "MB26-001",
      "web_name": "Alpine White",
      "name_key": "alpine-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI2LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB26-001.jpg",
      "search_text": "MB26-001 Alpine White Mid Range Residential",
      "sort_order": 126,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB26-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB26",
      "fabric_code": "MB26-002",
      "web_name": "Natural Wheat",
      "name_key": "natural-wheat",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI2LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB26-002.jpg",
      "search_text": "MB26-002 Natural Wheat Mid Range Residential",
      "sort_order": 127,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB26-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB26",
      "fabric_code": "MB26-003",
      "web_name": "Cement Gray",
      "name_key": "cement-gray",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI2LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB26-003.jpg",
      "search_text": "MB26-003 Cement Gray Mid Range Residential",
      "sort_order": 128,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB26-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB26",
      "fabric_code": "MB26-004",
      "web_name": "Shadow Iron",
      "name_key": "shadow-iron",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI2LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB26-004.jpg",
      "search_text": "MB26-004 Shadow Iron Mid Range Residential",
      "sort_order": 129,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB29-001",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB29",
      "fabric_code": "MB29-001",
      "web_name": "Fresh Cotton Breeze",
      "name_key": "fresh-cotton-breeze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI5LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB29-001.jpg",
      "search_text": "MB29-001 Fresh Cotton Breeze Mid Range Residential",
      "sort_order": 130,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB29-002",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB29",
      "fabric_code": "MB29-002",
      "web_name": "Warm Silk",
      "name_key": "warm-silk",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI5LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB29-002.jpg",
      "search_text": "MB29-002 Warm Silk Mid Range Residential",
      "sort_order": 131,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB29-003",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB29",
      "fabric_code": "MB29-003",
      "web_name": "Linen Taupe",
      "name_key": "linen-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI5LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB29-003.jpg",
      "search_text": "MB29-003 Linen Taupe Mid Range Residential",
      "sort_order": 132,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB29-004",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB29",
      "fabric_code": "MB29-004",
      "web_name": "Mist Gray",
      "name_key": "mist-gray",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI5LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB29-004.jpg",
      "search_text": "MB29-004 Mist Gray Mid Range Residential",
      "sort_order": 133,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB29-005",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB29",
      "fabric_code": "MB29-005",
      "web_name": "Granite Smoke",
      "name_key": "granite-smoke",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI5LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB29-005.jpg",
      "search_text": "MB29-005 Granite Smoke Mid Range Residential",
      "sort_order": 134,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB29-006",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB29",
      "fabric_code": "MB29-006",
      "web_name": "Deep Steel",
      "name_key": "deep-steel",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI5LTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB29-006.jpg",
      "search_text": "MB29-006 Deep Steel Mid Range Residential",
      "sort_order": 135,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-blackout-MB29-007",
      "roller_type": "roller",
      "shade_type": "blackout",
      "swatch_product_key": "roller-blackout",
      "tier": "Tier 2",
      "collection_label": "Mid Range Residential",
      "source_product_label": "Roller Shades Blackout - Mid Range Residential",
      "fabric_series": "MB29",
      "fabric_code": "MB29-007",
      "web_name": "Midnight Charcoal",
      "name_key": "midnight-charcoal",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTEzMjkyODgyNzYxMS1NQjI5LTAwNy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9132928827611-MB29-007.jpg",
      "search_text": "MB29-007 Midnight Charcoal Mid Range Residential",
      "sort_order": 136,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    }
  ]
};
